<template>
  <footer>
    <div v-html="htmlContent"></div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      htmlContent: "",
    };
  },
  mounted: function () {
    this.loadHtml()
  },
  methods: {
    loadHtml() {
      fetch("./2021tsuruha/tsuruha_htb_2021_2.html").then((res) => {
        res.text().then((html) => {
          this.htmlContent = html;
        });
      });
    },
  },
};
</script>

<style lang="sass" scoped>
footer
  margin: 20px auto 80px
  padding: 30px
</style>
